var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { width: "100%" } },
    [
      _c(
        "w-col",
        { staticClass: "qty-col", attrs: { lg: "1", sm: "4", xs: "12" } },
        [
          _vm.state.duration > 0 || _vm.state.toggleTimePicker
            ? _c("Duration", {
                attrs: {
                  label: _vm.$ct("sales-row.Duration"),
                  value: _vm.state.duration,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setDuration($event)
                  },
                },
              })
            : _c("w-input-number", {
                ref: "qty",
                attrs: {
                  decimals: _vm.decimalSettings.Qty,
                  label: _vm.$ct("sales-row.Qty"),
                  fancy: "",
                  autofocus: _vm.autoFocusQty,
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onUnitEnter()
                  },
                },
                model: {
                  value: _vm.state.amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "amount", $$v)
                  },
                  expression: "state.amount",
                },
              }),
          _c(
            "w-dropdown",
            {
              style: { padding: "7px 5px" },
              attrs: { items: _vm.qtyActions, flat: "", center: "", right: "" },
              on: {
                click: function ($event) {
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  )
                    return null
                  return _vm.trigger($event)
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "chevron-down", size: "xs" } })],
            1
          ),
        ],
        1
      ),
      !_vm.hideUnits
        ? _c(
            "w-col",
            { attrs: { lg: "2", sm: "3", xs: "12" } },
            [
              _c("app-unit-autocomplete", {
                ref: "unit",
                attrs: { label: _vm.unitLabel, fancy: "", lang: _vm.lng },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onUnitEnter()
                  },
                },
                model: {
                  value: _vm.state.unit,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "unit", $$v)
                  },
                  expression: "state.unit",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { lg: _vm.productSkuLg, sm: _vm.productSkuSm, xs: "12" } },
        [
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c("app-product-sku-autocomplete", {
                ref: "productSku",
                attrs: {
                  value: _vm.state.product,
                  "create-modal-if-not-exist": "",
                  "auto-focus": _vm.autoFocusSku,
                  "allow-multiple": "",
                  "remove-on-empty": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.onProductSkuSelect($event)
                  },
                  inputs: function ($event) {
                    return _vm.onMultipleProductsSkuSelect($event)
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onProductSkuEnter()
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("w-col", { attrs: { lg: "7", xs: "12" } }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("app-input-with-textarea-modal", {
              ref: "productDescription",
              staticClass: "mr grow",
              style: { flexGrow: 1 },
              attrs: {
                label: _vm.$ct("sales-row.Name"),
                fancy: "",
                "modal-title": _vm.$ct("sales-row.Name"),
                editor: true,
              },
              on: {
                paste: _vm.onPasteDescription,
                keyup: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onDescriptionBlur()
                  },
                  function ($event) {
                    return _vm.onKeyPress($event)
                  },
                ],
                confirm: function ($event) {
                  return _vm.onDescriptionChange()
                },
              },
              model: {
                value: _vm.state.productDescription,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "productDescription", $$v)
                },
                expression: "state.productDescription",
              },
            }),
            _c(
              "w-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct(`edit-translations`),
                    expression: "$ct(`edit-translations`)",
                  },
                ],
                staticClass: "cancel",
                style: { flexShrink: 0, width: "41px" },
                on: {
                  click: function ($event) {
                    _vm.translatedNamesModal = true
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "globe" } })],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "w-col",
        { attrs: { lg: "2", md: "5", xs: "6" } },
        [
          _c("w-input-number", {
            ref: "unitPrice",
            attrs: {
              decimals: _vm.decimalSettings.Unit,
              label: _vm.$ct("sales-row.UnitPrice"),
              value: _vm.state.unitPrice,
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setUnitPrice($event)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onUnitPriceBlur()
              },
              keydown: function ($event) {
                return _vm.$emit("unit-price-key-down", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "1-and-half", md: "3-and-half", xs: "6" } },
        [
          _c("w-input-number", {
            ref: "discount",
            attrs: {
              disabled: _vm.discountsDisabled,
              label: _vm.$ct("sales-row.Discount"),
              fancy: "",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onDiscountBlur()
              },
            },
            model: {
              value: _vm.state.discount,
              callback: function ($$v) {
                _vm.$set(_vm.state, "discount", $$v)
              },
              expression: "state.discount",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "1-and-half", md: "3-and-half", xs: "12" } },
        [
          _c("app-vat-select", {
            ref: "vatItems",
            attrs: {
              label: _vm.$ct("sales-row.Vat"),
              fancy: "",
              "use-object": "",
              "create-new-enabled": "",
              disabled: _vm.vatRegime == 2,
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onVatSelectBlur()
              },
              mouseup: function ($event) {
                return _vm.checkVatRegime.apply(null, arguments)
              },
            },
            model: {
              value: _vm.state.vatItem,
              callback: function ($$v) {
                _vm.$set(_vm.state, "vatItem", $$v)
              },
              expression: "state.vatItem",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "3", xs: "5" } },
        [
          _c("w-input-number", {
            ref: "netto",
            attrs: {
              decimals: _vm.decimalSettings.Unit,
              label: _vm.$ct("sales-row.NettoPrice"),
              value: _vm.state.netto,
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setNetto($event)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onNettoBlur()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "4", xs: "7" } },
        [
          _c(
            "w-row",
            { style: { flexWrap: "nowrap" }, attrs: { "no-padding": "" } },
            [
              _c("w-input-number", {
                ref: "bruto",
                staticClass: "mr",
                style: { flexGrow: 1, flexShrink: 1 },
                attrs: {
                  label: _vm.$ct("sales-row.BrutoPrice"),
                  value: _vm.state.bruto,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setBruto($event)
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onBrutoBlur()
                  },
                },
              }),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("tooltip.add-row"),
                      expression: "$ct('tooltip.add-row')",
                    },
                  ],
                  ref: "buttonAdd",
                  staticClass: "buttonAddSalesRow",
                  style: { flexShrink: 0 },
                  attrs: { lg: "", round: "" },
                  on: {
                    click: function ($event) {
                      return _vm.add()
                    },
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      )
                        return null
                      return _vm.add()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("input", {
                staticStyle: {
                  position: "absolute",
                  left: "-10000px",
                  top: "-500px",
                },
                attrs: { type: "text" },
                on: {
                  focus: function ($event) {
                    return _vm.focusQty()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.translatedNamesModal,
            callback: function ($$v) {
              _vm.translatedNamesModal = $$v
            },
            expression: "translatedNamesModal",
          },
        },
        [
          _c("app-edit-translated-names", {
            on: {
              close: function ($event) {
                return _vm.closeTranslationsModal()
              },
            },
            model: {
              value: _vm.state.translatedDescription,
              callback: function ($$v) {
                _vm.$set(_vm.state, "translatedDescription", $$v)
              },
              expression: "state.translatedDescription",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }